export const keys = {
  onboardingStatus: () => ['onboarding', 'status'] as const,
  completeOnboarding: () => ['onboarding', 'complete'] as const,
} as const;
